var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.8 44",
    style: {
      enableBackground: "new 0 0 50.8 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#206415;}\r\n\t.st1{fill:#62B243;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375_00000076582427347312084890000012294912419940005045_",
    className: "st0",
    d: "M39.9,32.9h-29c-3.2,0-5.8-2.6-5.8-5.8 c0,0,0,0,0,0V6.2c0-3.2,2.6-5.8,5.8-5.8c0,0,0,0,0,0h29c3.2,0,5.8,2.6,5.8,5.8c0,0,0,0,0,0v21C45.6,30.3,43,32.9,39.9,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,33.3C39.9,33.3,39.9,33.3,39.9,33.3h-29c0,0,0,0,0,0c-3.4,0-6.2-2.8-6.2-6.2V6.2c0-1.7,0.6-3.2,1.8-4.4 C7.7,0.6,9.2,0,10.9,0h29c0,0,0,0,0,0c3.4,0,6.2,2.8,6.2,6.2v21C46,30.5,43.3,33.3,39.9,33.3z M10.9,32.4h29c0,0,0,0,0,0 c2.9,0,5.3-2.4,5.3-5.3v-21c0-3-2.4-5.3-5.3-5.3c0,0,0,0,0,0h-29c-3,0-5.3,2.4-5.3,5.3v20.9C5.6,30,8,32.4,10.9,32.4 C10.9,32.4,10.9,32.4,10.9,32.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376_00000033341202134942175040000005337712667152371089_",
    className: "st0",
    d: "M6.3,33.3H2.8c-1.2,0-2.3-1-2.3-2.2 V14.4c0-1.2,1-2.3,2.2-2.3h3.7c1.2,0,2.3,1,2.3,2.2V31c0.1,1.2-0.8,2.2-1.9,2.3H6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,33.7H2.8c-1.5,0-2.7-1.2-2.8-2.6V14.4c0-1.5,1.2-2.7,2.6-2.8h3.7c1.5,0,2.7,1.2,2.8,2.6V31 c0.1,1.4-0.9,2.6-2.3,2.8L6.3,33.7z M2.7,12.5c-1,0-1.8,0.9-1.8,1.9v16.7c0,1,0.9,1.8,1.9,1.8h4C7.6,32.8,8.3,32,8.2,31l0-16.8 c0-1-0.9-1.8-1.9-1.8H2.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377_00000047052365708854576760000012316514262010091679_",
    className: "st0",
    d: "M48,33.3h-3.6c-1.2,0-2.3-1-2.3-2.2 V14.4c0-1.2,1-2.3,2.2-2.3H48c1.2,0,2.3,1,2.3,2.2V31C50.4,32.3,49.3,33.3,48,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,33.7h-3.6c-1.5,0-2.7-1.2-2.8-2.6V14.4c0-1.5,1.2-2.7,2.6-2.8H48c1.5,0,2.7,1.2,2.8,2.6V31 C50.8,32.5,49.5,33.7,48,33.7L48,33.7z M44.4,12.5c-1,0-1.8,0.9-1.8,1.9v16.7c0,1,0.9,1.8,1.9,1.8H48c1,0,1.9-0.9,1.9-1.9V14.3 c0-1-0.9-1.8-1.9-1.8H44.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378_00000158004391240022590250000010959496069385799318_",
    className: "st0",
    d: "M9.2,32.7h32.1c2.3,0,4.1,1.9,4.2,4.2 l0,0c0,3.7-3,6.7-6.7,6.7H12c-3.7,0-6.7-3-6.7-6.7l0,0c-0.1-2.1,1.5-4,3.6-4.2H9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,43.9c-3.9,0-7.1-3.2-7.1-7.1c-0.1-2.4,1.7-4.4,4-4.6l0.2,0h32.1c2.5,0.1,4.5,2.1,4.6,4.6 c0,3.9-3.2,7.1-7.1,7.1H12z M9,33.1c-1.9,0.2-3.3,1.8-3.2,3.7c0,3.4,2.8,6.2,6.3,6.3h26.7c3.4,0,6.2-2.8,6.3-6.3 c0-2-1.7-3.7-3.7-3.7H9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatSelected);
export default __webpack_public_path__ + "static/media/seat_selected.1d3c27c7ccafbb1e4ef589c6ff934397.svg";
export { ForwardRef as ReactComponent };